// extracted by mini-css-extract-plugin
export var colorSquare = "_s3-0";
export var danger = "_s3-5";
export var lightPink = "_s3-8";
export var neutralBlue = "_s3-7";
export var neutralYellow = "_s3-6";
export var normal = "_s3-1";
export var primary = "_s3-2";
export var primaryLight = "_s3-3";
export var solidBlack = "_s3-g";
export var solidGreen = "_s3-b";
export var solidLightBlue = "_s3-d";
export var solidNavy = "_s3-c";
export var solidOrange = "_s3-f";
export var solidPink = "_s3-e";
export var solidRed = "_s3-9";
export var solidYellow = "_s3-a";
export var success = "_s3-4";